import {ORM, Model, fk, many, attr} from 'redux-orm';

// import {LOAD_STOPTIMES, LOAD_ORDER, UPDATE_ORDER_LINE} from 'ducks/gtfs';

export class Stop extends Model {
    static get modelName() { return 'Stop'; }

    static get fields() {
        return {

        }
    }
}


export class Route extends Model {
    static get modelName() { return 'Route'; }

    static options = {
        idAttribute: 'route_id',
    };

    static get fields() {
        return {
            agency: attr(),
            competent_authority: attr(),
            route_color: attr(),
            route_id: attr(),
            route_long_name: attr(),
            route_short_name: attr(),
            route_type: attr(),
        }
    }

    toString = () => `Route ${this.route_short_name} ${this.route_long_name}`;
}



export class StopTime extends Model {
    static get modelName() { return 'StopTime'; }

    static get fields() {
        return {
            day: attr(),
            departure_time: attr(),
            destination: attr(),
            drop_off_type: attr(),
            id: attr(),
            overnight: attr(),
            pickup_type: attr(),
            route_short_name: attr(),
            stop_sequence: attr(),
            trip_id: attr(),
            wheelchair: attr(),
            route: fk('Route', 'departures'),
        };
    }

    static reducer(action, StopTime, session) {
        switch(action.type) {
            case 'LOAD_STOPTIMES': {
                action.routes.map(route => {
                    const {upcoming_departures, ...rest} = route;
                    session.Route.upsert(rest);
                    upcoming_departures.forEach(dep => {
                        StopTime.upsert({...dep, route: route.route_id});
                    });
                });
                break;
            }
            case 'CREATE_ORDER': {
                Order.create(action.payload);
                break;
            }
            case 'UPDATE_ORDER': {
                Order.withId(action.payload.id).update(action.payload);
                break;
            }
            case 'DELETE_ORDER': {
                const order = Order.withId(action.payload.id);
                order.delete();
                break;
            }

            return undefined;
        }
    };

    toString = () => `StopTime ${this.id}`;
}

export const orm = new ORM();
orm.register(Route, StopTime);

export default orm;



// WEBPACK FOOTER //
// ./src/models/models.js